var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39994 4.00005C2.39994 4.84874 2.73708 5.66267 3.3372 6.26279C3.93732 6.86291 4.75125 7.20005 5.59994 7.20005C6.44863 7.20005 7.26257 6.86291 7.86268 6.26279C8.4628 5.66267 8.79994 4.84874 8.79994 4.00005C8.79994 3.15136 8.4628 2.33742 7.86268 1.73731C7.26257 1.13719 6.44863 0.800049 5.59994 0.800049C4.75125 0.800049 3.93732 1.13719 3.3372 1.73731C2.73708 2.33742 2.39994 3.15136 2.39994 4.00005Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799938 15.1999V13.5999C0.799938 12.7512 1.13708 11.9373 1.7372 11.3372C2.33731 10.737 3.15125 10.3999 3.99994 10.3999H7.19994C8.04863 10.3999 8.86256 10.737 9.46268 11.3372C10.0628 11.9373 10.3999 12.7512 10.3999 13.5999V15.1999",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1999 0.904053C11.8883 1.08029 12.4984 1.48061 12.9341 2.0419C13.3697 2.60319 13.6062 3.29352 13.6062 4.00405C13.6062 4.71459 13.3697 5.40492 12.9341 5.9662C12.4984 6.52749 11.8883 6.92781 11.1999 7.10405",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 15.2V13.6C15.1959 12.8937 14.9583 12.2087 14.5242 11.6515C14.09 11.0944 13.4838 10.6966 12.7999 10.52",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.b330b17a5b1149a03654e26518633f23.svg";
export { ForwardRef as ReactComponent };